import { Component, OnInit } from '@angular/core';
//服务
import { EditStudentService } from '../edit-student.service';
import { LoginUserService } from '../../../core/services/login-user.service';
import { MessageService } from '../../../core/services/message.service';
import { Router } from "@angular/router";
@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.scss']
})
export class UserDataComponent implements OnInit {
  form: any;
  public formData: any = {}; //学生信息
  public stuId: string;//学生id
  public headimg: string;
  public errorColor: string = null;//错误提示
  constructor(
    private _eidtStuService: EditStudentService,
    private _login: LoginUserService,
    private _msg: MessageService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.stuId = this._login.getLoginInfo()['student_id'];
    this.getUserData();//获取用户资料
  }
  //获取用户资料
  getUserData() {
    this._eidtStuService.getStudentBaseData(this.stuId).then(resp => {
      let item = resp['data'];
      this.formData = {
        id: item['id'],
        nickname: item['nickname'],
        headimg: item['headimg'],
        phone: item['phone'],
        email: item['email']
      }
    })
  }

  //上传图片
  savePic(event) {
    this.headimg = event;
    this.formData['headimg'] = event;
  }
  onBlurForm() {
    this.errorColor = '';
  }
  //数据验证
  regUsername() {
    let name_reg = new RegExp(/^[a-z0-9\u4E00-\u9FA5]{2,12}$/g);
    if (!!this.formData.nickname) {
      this.formData.nickname = this.formData.nickname.trim();
      if (!name_reg.test(this.formData.nickname)) {
        this.errorColor = 'name';
        this._msg.warn('昵称在2-12个字符');
        setTimeout(() => { this._msg.clear(); }, 3000);
        return false;
      }
      return true;
    }
  }
  regUserphone() {
    let phone_reg = new RegExp(/^[1]\d{10}$/g);
    if (!!this.formData.phone) {
      this.formData.phone = parseInt(this.formData.phone.toString().trim());
      this.formData.phone = this.formData.phone;
      if (!phone_reg.test(this.formData.phone)) {
        this.errorColor = 'phone';
        this._msg.warn('手机格式不正确，请从新输入');
        setTimeout(() => { this._msg.clear(); }, 3000);
        return false;
      }
      return true;
    }
  }
  regUseremail() {
    let email_reg = new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/g);
    if (!!this.formData.email) {
      this.formData.email = this.formData.email.trim();
      if (!email_reg.test(this.formData.email)) {
        this.errorColor = 'email';

        this._msg.warn('邮箱格式不正确，请从新输入');
        setTimeout(() => { this._msg.clear(); }, 3000);
        return false;
      }
      return true;
    }
  }
  saveBaseData() {
    if (!this.formData.email && !this.formData.nickname && !this.formData.phone && !(this.formData['headimg'] === this.headimg)) {
      this._msg.info('你还没有编辑任何信息');
      return false;
    }
    this._eidtStuService.postStudentBaseData(this.formData).then(resp => {
      if (resp.success) {
        this.getUserData();//获取用户资料
        this._msg.success('资料修改成功');
        let obj = JSON.parse(localStorage.getItem('cshixi'));
        obj['headimg'] = this.formData['headimg'];
        this._login.setLogin(obj);
        this._router.navigate(['/user/student/student-center']);
        setTimeout(() => { this._msg.clear(); }, 3000);
      } else {
        this._msg.warn('资料修改失败');
        setTimeout(() => { this._msg.clear(); }, 3000);
      }

    })
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/user-data/user-data.component.ts